import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { alert_error, alert_success } from '../AppContext';

import axios from 'axios';
function Gioithieuzalo() {
  const navigate = useNavigate();
  const [nutxuly, setnutxuly] = useState(0);
  const [iduser_ref, setiduser_ref] = useState('');
  const [id_zalo, setid_zalo] = useState('');
  useEffect(() => {
    // Lấy chuỗi query parameters từ URL
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const iduserRef = urlParams.get('iduser_ref');
    const idZalo = urlParams.get('id_zalo');
    setiduser_ref(iduserRef);
    setid_zalo(idZalo);
    // In ra giá trị để kiểm tra
    console.log('ID User Ref:', idZalo);
    // alert(iduserRef);
    // Các thao tác khác với giá trị iduserRef
  }, []); // Dependency array để đảm bảo useEffect chỉ chạy một lần sau khi component mount
  const [inputlienket, setinputlienket] = useState('');
  const [nutorder, setnutorder] = useState('Ấn đây để rút tiền');
  function switch_router(link) {
    navigate(link);
  };
  function thanhcong() {
    alert_success("💰 Nhận tiền thành công! 📲 Tải app để kiếm thêm nào! 💸");
    switch_router("/reactapp/thankiu");
  };
  function handleSubmit(event) {
    setnutxuly(0);
    // const apikey = Cookies.get('apikey');
    event.preventDefault();

    setnutxuly(1);
    setnutorder('Please wait a moment 😊');
    if (!inputlienket) {
      alert('Please điền đầy đủ thông tin')
      setnutxuly(0);
      setnutorder('điền đủ thông tin');
      return
    }
    axios
      .post('https://hust.media/api/payzalo.php', {
        iduser_ref: iduser_ref,
        sdt_zalo: inputlienket,
        id_zalo: id_zalo
      })
      .then(response => (testFunction(response)))
      .catch(error => console.log(error))
  };
  function testFunction(response) {
    const info = response.data;
    const status = info.status;
    const message = info.message;
    setnutorder('đặt tiếp luôn nào')
    setnutxuly(0);
    if (status == 0) {
      alert_error(info.message);
    }
    else if (status == 1) {
      alert_success(info.message);
    }
    if (info.redirect != null && info.redirect != '') {
      setTimeout(function () {
        // Chuyển hướng sang trang web khác
        window.location.href = info.redirect;
      }, 1700);
    }
  };
  return (
    <div className="max-w-2xl px-1 py-1  mx-auto rounded-lg shadow-xl">
      <div className="container-fluid mx-2">
        <div style={{ textAlign: "center" }} className="mt-4 justify-center items-center ">
          <label>Nhập số điện thoại Momo của bạn</label>
          <br />
          <div className="input-group flex-nowrap ">
            <span className="input-group-text" id="addon-wrapping">
              sdt
            </span>
            <input
              type="number"
              id="inputlienket"
              className="mt-1 text-lg p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:border-blue-300"
              placeholder="Điền số điện thoại ở đây"
              value={inputlienket}
              onChange={(e) => setinputlienket(e.target.value)}
            />
          </div>
          <div >
            <div className="mt-1 text-lg"> 📲 Chúng tôi chuyển tiền 💲 để bạn giới thiệu sản phẩm. An toàn và bảo mật tuyệt đối! 🔐
            </div>
            <div onClick={() => thanhcong()}  >
              Không có MoMo? Ấn đây để 💸 kiếm tiền ngay! 🚀
            </div> </div>
          <button disabled={nutxuly == 1} onClick={handleSubmit}
            className='mt-3 flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-3 w-full dark:bg-slate-800 dark:text-white'>
            <div className='flex items-center justify-between flex-1'>
              {nutxuly == 1 &&
                <div className="spinner-border" role="status">

                </div>}


              <span className='text-lg font-medium text-white'>
                {nutorder} </span>
              <div className="text-xl">
                {'\u27A4'}
              </div>
            </div>
          </button>
        </div>   </div>  </div>
  );
}


export default Gioithieuzalo;